<template>
  <div>
    <v-alert type="info" text>
      Die Schüler:innen GYM1-GYM4 machen zu Beginn des Schuljahres einen
      Check-in, d.h. sie kontrollieren und bestätigen ihre Personalien.
    </v-alert>
    <v-card>
      <v-toolbar flat>
        <v-switch
          inset
          v-model="filter.showTodo"
          label="Nur nicht-abgeschlossene Checkins anzeigen"
          hideDetails
        />

        <v-spacer></v-spacer>
        <v-btn outlined text color="danger" @click="resetCheckin()"
          >Status zurücksetzen</v-btn
        >
      </v-toolbar>

      <v-data-table
        :items="itemsSearched"
        :headers="headers"
        :loading="loading"
      >
        <template v-slot:item.person="{ item }">
          <PersonItem small :value="item.person" />
        </template>
        <template v-slot:item.checkedIn="{ item }">
          <v-simple-checkbox
            v-model="item.checkedIn"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.hasConfirmed="{ item }">
          <v-simple-checkbox
            v-model="item.hasConfirmed"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.open="{ item }">
          <v-simple-checkbox v-model="item.open" disabled></v-simple-checkbox>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { comparePeople, searchPerson } from "common/utils/people.js";

import PersonItem from "common/components/PersonItem.vue";
import ReportButton from "@/components/ReportButton";
import { filter } from "lodash";

export default defineComponent({
  name: "OnBoardingCheckinGYM1",
  props: ["search"],
  components: { PersonItem, ReportButton },
  data() {
    return {
      loading: false,
      items: [],
      filter: {
        showTodo: false,
      },
      headers: [
        {
          text: "Schüler:in",
          value: "person",
          sort: comparePeople,
        },
        {
          text: "Status Personalien",
          value: "checkedIn",
          align: "center",
        },
        {
          text: "Anmeldung offen",
          value: "open",
          align: "center",
        },
      ],
    };
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "onboarding/checkin",
      });
      this.loading = false;
    },
    async resetCheckin() {
      if (
        await this.$root.confirm({
          message: `Der Checkin-Status aller Schüler:innen GYM1-GYM4 wird zurückgesetzt. Dies kann nicht rückgängig gemacht werden.`,
          color: "danger",
          icon: "mdi-alert",
        })
      ) {
        this.resetting = true;
        await this.apiPost({
          resource: "onboarding/checkin",
          data: { action: "reset" },
        });
        this.fetchData();
        this.resetting = false;
      }
    },
  },
  computed: {
    itemsSearched() {
      if (!this.search) {
        return this.itemsFiltered;
      }
      return this.itemsFiltered?.filter((el) =>
        searchPerson(el.person, this.search)
      );
    },
    itemsFiltered() {
      if (this.filter.showTodo) {
        return filter(this.items, (item) => !item.checkedIn);
      }
      return this.items;
    },
  },
  async created() {
    this.fetchData();
  },
});
</script>
